import React from "react";
import ScaleLoader from "react-spinners/ScaleLoader";
import { Icon } from "../../_components";

export function StatusIndicator({ status, onClear }) {
  // console.log('STATUS:', status);
  const handleClear = () => {
    if (onClear) onClear();
  };
  let Component;
  switch (status) {
    case "loading":
      Component = (
        <span className="chronos-search-loader">
          <ScaleLoader height={18} width={3} />
        </span>
      );
      break;
    case "search":
      Component = <Icon icon="far fa-times fa-fw" onClick={handleClear} />;
      break;
    default:
      Component = <Icon icon="far fa-search fa-fw" />;
  }

  return <span className="chronos-global-search-status">{Component}</span>;
}
